<template>
  <div>
    <NavBar />
    <div class="control-panel">
      <div class="control-panel__tabsWrapper">
        <b-tabs
          no-nav-style
          v-model="tabIndex"
          class="control-panel__tabs"
        >
          <b-tab
            v-for="(tab, idx) in tabs"
            :key="tab.key"
            >
            <template
              slot="title"
              >
              <span
                class="control-panel__tabTrigger"
              >
                {{ tab.title }}
                <icon
                  name="circle"
                  v-if="tabIndex === idx"
                  scale="0.5"
                />
              </span>
            </template>
            <div class="control-panel__tabContent">
              <UserAccess
                v-if="tab.key === 'uAccess'"
              />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
// components
import NavBar from '@/components/NavBar'
import UserAccess from './UserAccess'

export default {
  components: {
    NavBar,
    UserAccess
  },
  data () {
    return {
      tabIndex: 0,
      tabs: [
        {
          title: 'User Access',
          key: 'uAccess'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.control-panel {
  position: relative;
  display: flex;
  &__tabsWrapper {
    width: 100%;
    height: calc(100vh - 60px);
    background-color: white;
    margin-bottom: -3px;
    .tab-pane {
      padding: {
        top: 10px;
        bottom: 10px;
      }
    }
    .nav-link.active .dashboard__editTab {
      display: inline-block;
    }
    .tabs-component-panel {
      padding-bottom: 60px;
    }
  }
  &__tabs {
    > div:first-child {
      background: white;
      > .nav > li > a {
        padding: 7px 10px;
      }
    }

    > .tab-content {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: calc(100vh - 100px);
      overflow: auto;
      background-color: #f8f9fe;
      box-shadow: inset 1px 2px 2px rgba(0, 0, 0, .2);
      padding: 0 10px;
      .tab-pane {
        outline: none;
      }
    }
  }
  &__tabTrigger {
    position: relative;
    z-index: 5;
    font: {
      family: 'Open Sans',sans-serif;
      weight: 600;
    }
    text-transform: uppercase;
    svg {
      vertical-align: 1px;
    }
  }
  .table {
    background: white;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ControlPanel/index.vue